<template>
  <div class="home dib100">
    <template>
</template>
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: "home",
  data: () => ({
    menu: false,
    loading:false,
    arrItems:[]
  }),
  components: {
  },
  methods:{

      async refresh() {
      console.log("inside refersf");

      this.loading = true;
      //this.arrItems = await api.getClients();
      this.loading = false;
    },

    async login(){
         //await axia.postAxia();
    }
  }
};
</script>
